import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {
    marginTop: 32
  },
  title: {
    color: '#a1a1a1',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: '.25px',
    marginBottom: 0,
    marginTop: 24,
    paddingBottom: 4,
    paddingTop: 8,
    paddingLeft: 24
  },
  content: {
    borderRadius: 3,
    overflow: 'hidden',
    boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
    background: 'white',
    marginBottom: 16,
    marginTop: 16
  },
  loadingWrapper: {
    padding: 10
  },
  loader: {
    maring: 'auto 0'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/content-card/content-card-styles.js